const admin = 'admin'
const agencyHead = 'agency-head'
const agencyStaff = 'agency-staff'
const stateHead = 'state-head'
const stateStaff = 'state-staff'
const heads = [agencyHead, stateHead]
const staff = [agencyStaff, stateStaff]
const stateAgents = [stateHead, stateStaff]
const agencyAgents = [agencyHead, agencyStaff]
const agents = [...stateAgents, ...agencyAgents]

export default {
	admin,
	agencyHead,
	agencyStaff,
	stateHead,
	stateStaff,
	heads,
	staff,
	stateAgents,
	agencyAgents,
	agents,
	all: [admin, ...agents]
}
